import gql from 'graphql-tag';

export const ALL_HOLDINGS_DATE = (isEtf) =>
    isEtf
        ? gql`
              query fullHoldingsDate($ticker: String!) {
                  exchangeTradedFund(ticker: $ticker) {
                      transparencyTypeName
                      fullHoldings {
                          asOfDate
                      }
                  }
              }
          `
        : gql`
              query fullHoldingsDate($ticker: String!) {
                  mutualFund(ticker: $ticker) {
                      fullHoldings {
                          asOfDate
                      }
                  }
              }
          `;

export const MF_ALL_HOLDINGS = gql`
    query fullHoldings($ticker: String!, $asOfDate: Date!) {
        mutualFund(ticker: $ticker) {
            name
            assetClassName
            broadAssetClass
            investmentStyleName
            bond
            inceptionDate
            fullHoldings(asOfDate: $asOfDate) {
                asOfDate
                individualHoldings {
                    name
                    shareQuantity
                    marketValue
                    percentTotalNetAssets
                    holdingCouponRate
                    holdingMaturityDate
                    industryName
                }
            }
        }
    }
`;

export const ETF_ALL_HOLDINGS = gql`
    query fullHoldings($ticker: String!, $asOfDate: Date!) {
        exchangeTradedFund(ticker: $ticker) {
            name
            assetClassName
            transparencyTypeName
            inceptionDate
            fullHoldings(asOfDate: $asOfDate) {
                asOfDate
                individualHoldings {
                    name
                    ticker
                    shareQuantity
                    marketValue
                    percentTotalNetAssets
                    holdingCouponRate
                    holdingMaturityDate
                    investmentType
                    strikePrice
                    prioritizedIdentifier
                    issueDate
                }
            }
        }
    }
`;
